import { render, staticRenderFns } from "./dealerConfirmation.vue?vue&type=template&id=97424c14&scoped=true"
import script from "./dealerConfirmation.vue?vue&type=script&lang=js"
export * from "./dealerConfirmation.vue?vue&type=script&lang=js"
import style0 from "./dealerConfirmation.vue?vue&type=style&index=0&id=97424c14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97424c14",
  null
  
)

export default component.exports